import React from 'react';
import classNames from 'classnames';
import { themr } from 'react-css-themr';

import NewWordModal from './NewWordModal';
import baseWordPickerTheme from './WordPicker.scss';
import { CdnContext } from '../../context';

class WordPicker extends React.Component {
    constructor(props) {
        super(props);

        const { max = -1, words } = props;

        this.state = {
            max,
            chosenWords: [],
            words,
        };
    }

    componentWillMount() {
        this.setInitialAnswer();
    }

    componentWillUnmount() {
        const { chosenWords } = this.state;
        const { part, section, setAnswer } = this.props;

        setAnswer({
            part,
            section,
            answer: chosenWords,
        });
    }

    setInitialAnswer() {
        const { answer, onStateChange } = this.props;

        if (
            this.state.chosenWords.length === 0 &&
            answer &&
            answer.length > 0
        ) {
            this.setState({
                chosenWords: answer,
            });
            onStateChange(true);
        }
    }

    isWordChosen(word) {
        return this.state.chosenWords.findIndex(w => w.word === word.word) > -1;
    }

    isLimitReached() {
        const { max } = this.props;
        const { chosenWords } = this.state;

        return chosenWords.length >= max;
    }

    validState() {
        const { chosenWords } = this.state;

        if (chosenWords.length < 1) {
            return false;
        }

        return true;
    }

    handleWordClick(word) {
        const { chosenWords, max } = this.state;
        const { onStateChange } = this.props;

        if (this.isWordChosen(word)) {
            chosenWords.splice(
                chosenWords.findIndex(w => w.word === word.word),
                1
            );
        } else if (chosenWords.length < max || max === -1) {
            chosenWords.push(word);
        }

        this.setState({
            chosenWords,
        });

        onStateChange(this.validState());
    }

    handleAddWord = (word) => {
        const { words, chosenWords } = this.state;
        const {
            toggleModal, onStateChange, section, max,
        } = this.props;
        let value;

        if (section === 'positief') {
            value = {
                word, icon: '/assets/images/emoticons/kalm@2x.png', filename: 'kalm@2x.png', name: 'kalm@2x',
            };
        } else if (section === 'negatief') {
            value = {
                word, icon: '/assets/images/emoticons/ongelukkig@2x.png', filename: 'ongelukkig@2x.png', name: 'ongelukkig@2x',
            };
        } else {
            value = { word };
        }
        words.push(value);

        if (chosenWords.length < max) {
            chosenWords.push(value);
        }

        this.setState({
            words,
            chosenWords,
        });

        onStateChange(this.validState());
        toggleModal();
    };

    render() {
        const { words } = this.state;
        const {
            theme, modalOpen, toggleModal, header,
        } = this.props;

        return (
            <div className={theme.root}>
                <h2 className="question-heading">{header.title}</h2>
                <div className="question-description">
                    <p>{header.description}</p>
                </div>
                <div className={theme.wordPicker}>
                    <CdnContext.Consumer>
                        {cdn =>
                            words.map(word => (
                                <div
                                    key={word.word}
                                    onClick={() => {
                                        this.handleWordClick(word);
                                    }}
                                    className={classNames(
                                        'no-select word',
                                        theme.word,
                                        {
                                            [theme.chosen]:
                                                this.isWordChosen(word),
                                            chosen:
                                                this.isWordChosen(word),
                                        },
                                        {
                                            [theme.disabled]:
                                                this.isLimitReached(),
                                        }
                                    )}
                                >
                                    {word.word}{' '}
                                    {word.icon && (
                                        <img
                                            src={`${cdn}assets/images/emoticons/${
                                                word.filename
                                            }`}
                                            alt={word.word}
                                        />
                                    )}
                                </div>
                            ))
                        }
                    </CdnContext.Consumer>
                </div>
                <NewWordModal
                    onClose={toggleModal}
                    onAddWord={this.handleAddWord}
                    open={modalOpen}
                />
            </div>
        );
    }
}

export default themr('WordPicker', baseWordPickerTheme)(WordPicker);



// WEBPACK FOOTER //
// ./src/components/questions/WordPicker.js